import { useMemo } from 'react';
import clsx from 'clsx';
import parse from 'html-react-parser';
import { ChefHat, DullLightBulb, SnowFlake } from '@hungryroot/icons';
import { Paragraph } from '@hungryroot/ramen';
import styles from './AdditionalProductInfo.module.css';

interface Props {
  description?: string;
  refrigerate?: boolean;
  instructions?: string;
  // this is an HTML string
  tip?: string;
}

export function AdditionalProductInfo(props: Props) {
  const { description, refrigerate, instructions, tip } = props;

  const parsedDescription = useMemo(() => {
    if (description === undefined) {
      return undefined;
    }
    return parse(description);
  }, [description]);

  const parsedTip = useMemo(() => {
    if (tip === undefined) {
      return undefined;
    }
    return parse(tip);
  }, [tip]);

  return (
    <div className={styles.container}>
      {parsedDescription && (
        <div className={styles.description}>
          <Paragraph>{parsedDescription}</Paragraph>
        </div>
      )}
      {refrigerate && (
        <div className={styles.row}>
          <SnowFlake />
          <Paragraph className={styles.text}>Refrigerate</Paragraph>
        </div>
      )}
      {instructions && (
        <div className={styles.row}>
          <ChefHat />
          <Paragraph className={clsx(styles.text, styles['parsed-html'])}>
            {parse(instructions)}
          </Paragraph>
        </div>
      )}
      {parsedTip !== undefined ? (
        <div className={styles.row}>
          <DullLightBulb />
          <Paragraph className={clsx(styles.text, styles['parsed-html'])}>
            Tip: {parsedTip}
          </Paragraph>
        </div>
      ) : null}
    </div>
  );
}
